import { defineMessages } from 'react-intl';

export default defineMessages({
  filesOption: {
    id: 'frontbucket.repository.source.filterModeSelector.filesOption',
    description: 'Filter mode selector dropdown files option',
    defaultMessage: 'Files',
  },
  codeOption: {
    id: 'frontbucket.repository.source.filterModeSelector.codeOption',
    description: 'Filter mode selector dropdown code option',
    defaultMessage: 'Code',
  },
  tooltipLabel: {
    id: 'frontbucket.repository.source.filterModeSelector.tooltipLabel',
    description: 'Filter mode selector dropdown tooltip label',
    defaultMessage: 'Search for files or code in this repo',
  },
  codeSearchDisabled: {
    id: 'frontbucket.repository.source.filterModeSelector.codeSearchDisabled',
    description: 'Tooltip label displayed when code search is disabled',
    defaultMessage:
      'You can only filter files in this branch. To search for code, go to the main branch.',
  },
});
